import React from "react";
import './OriginalBrands.css';
import { Link, useNavigate } from 'react-router-dom';
import phone from "../components/assets/images/combo-1.webp";
import perfume from "../components/assets/images/combo-2.webp";
import bag from "../components/assets/images/combo-3.webp";
import footwear from "../components/assets/images/combo-4.webp";
import book from "../components/assets/images/combo-5.webp";
import pen from "../components/assets/images/combo-6.webp";
import phones from "../components/assets/images/combo-7.webp";

import { useCart } from '../components/cart/CartContext';

const brands = [
  {
    title: "Combo Pack of Shilajit Gold Dust – 20g + Safed Musli 90 Capsules",
    image: phone,
    id: 1,
    price: 12999
  },
  {
    title: "Combo Pack of Shilajit 90 Capsules & Ashwagandha 90 Capsules",
    image: perfume,
    id: 2,
    price: 799
  },
  {
    title: "Combo Pack of Pure Shilajit Resin 30g & Kashmiri Kesar 1g",
    image: bag,
    id: 3,
    price: 1499
  },
  {
    title: "Upakarma Ayurveda Pure Ashwagandha 90 Capsules 500mg – Pack of 2",
    image: footwear,
    id: 4,
    price: 1299
  },
  {
    title: "Combo Pack of Shilajit Gold Dust – 20g + Safed Musli 90 Capsules",
    image: book,
    id: 5,
    price: 499
  },
  {
    title: "Combo Pack of Shilajit Capsules & Ashwagandha Effervescent",
    image: pen,
    id: 6,
    price: 99
  },
  {
    title: "Combo Pack of Shilajit Gold Dust – 20g + Safed Musli 90 Capsules",
    image: phones,
    id: 7,
    price: 8499
  },
];

const OriginalBrands = () => {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleAddToCart = (product) => {
    addToCart(product);
    navigate('/cart');
  };

  return (
    <section className="original-brands-section">
      <div className="brand-header">
        <h2>BEST SELLING <span className="verified"> COMBOS</span></h2>
        <Link to="/Combo" className="all-blogs-link">VIEW ALL &gt;</Link>
      </div>

      <div className="brand-scroll">
        {brands.map((item) => (
          <div key={item.id} className="brand-card">
            <img src={item.image} alt={item.title} className="brand-img" />
            <div className="brand-info">
              <div className="brand-title">{item.title}</div>
              <div className="brand-price">₹{item.price.toLocaleString()}</div>
              <button className="add-cart-btn" onClick={() => handleAddToCart(item)}>ADD TO CART</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OriginalBrands;
